import axios from 'axios'

const HTTP = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        'Accept': 'application/json'
    },
    withCredentials: true
});

const catchApiError = function (error) {
    if (error.response && error.response.data && error.response.data.error) {
        return error.response.data.error;
    }

    return error;
};

export {
    HTTP,
    catchApiError
}
